import React, { useContext, useEffect, useState } from "react";
import {
  useExpanded,
  useSortBy,
  useTable,
  useGlobalFilter,
  usePagination,
} from "react-table";
import styles from "./styles/Assets.module.css";
import downArrow from "../User/down.svg";
import upArrow from "../User/up.svg";
import upDownArrow from "../User/updownarrow.svg";
import cashImg from "./styles/img/cash.png";
import TableFooter from "../User/TableFooter/TableFooter";
import { LanguageContext } from "../../Context/changeLanguageProvider";
// import TableFilter from "./TableFilter";
export function AssetTable({
  click,
  columns,
  data,
  filter,
  setFilter,
  assetsLength,
}) {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    nextPage,
    previousPage,
    canNextPage,
    canPreviousPage,
    setPageSize,
    prepareRow,
    setGlobalFilter,
    pageOptions,
    state,
  } = useTable(
    { columns, data, autoResetExpanded: false },
    useGlobalFilter,
    useSortBy,
    useExpanded,
    usePagination
  );
  const { pageIndex, pageSize } = state;
  useEffect(() => {
    setGlobalFilter(filter);
  }, [setGlobalFilter, filter]);
  const websiteCurrentLang = useContext(LanguageContext).language;
  const [content, setContent] = useState(
    websiteCurrentLang.content.Beneficiary.AssetsTable
  );
  const [dublicatedcontent, setDublicatedContent] = useState(
    websiteCurrentLang.content.DublicatedText
  );
  useEffect(() => {
    setContent(websiteCurrentLang.content.Beneficiary.AssetsTable);
    setDublicatedContent(websiteCurrentLang.content.DublicatedText);
  }, [websiteCurrentLang]);
  return (
    <>
      <table {...getTableProps()} className={styles.sub_table_div}>
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr
              className={styles.head_row}
              {...headerGroup.getHeaderGroupProps()}
            >
              {headerGroup.headers.map((column) => (
                <th
                  className={styles.th}
                  {...column.getHeaderProps(column.getSortByToggleProps())}
                >
                  <span style={{ cursor: column.canSort ? "pointer" : "auto" }}>
                    {column.render("Header")}
                  </span>
                  <div
                    className={styles.sort_icon}
                    style={{
                      display: "inline-flex",
                      position: "absolute",
                      background: `url(${
                        column.canSort
                          ? column.isSorted
                            ? column.isSortedDesc
                              ? downArrow
                              : upArrow
                            : upDownArrow
                          : ""
                      }) no-repeat center`,
                      backgroundSize: "contain",
                    }}
                  />
                </th>
              ))}
            </tr>
          ))}
        </thead>
        {assetsLength.length ? (
          <tbody {...getTableBodyProps()}>
            {page.map((row, i) => {
              prepareRow(row);
              return (
                // <React.Fragment key={...row.getRowProps().key}>
                <React.Fragment key={row.getRowProps().key}>
                  <tr
                    onClick={() => click(row.original)}
                    className={styles.row}
                    style={{
                      height: "81px",
                    }}
                  >
                    {row.cells.map((cell) => {
                      if (cell.column.id === "deleter") {
                        return (
                          <td className={styles.td} {...cell.getCellProps()}>
                            {cell.render("Cell")}
                          </td>
                        );
                      } else if (cell.column.id === "expander") {
                        return (
                          <td className={styles.td} {...cell.getCellProps()}>
                            {cell.render("Cell")}
                          </td>
                        );
                      } else if (cell.column.id === "trustees") {
                        let cellLength = cell.row.values.trustees.length;
                        console.log(cellLength);

                        return (
                          <td
                            className={
                              styles[`td_${cell.column.id.replace(" ", "")}`]
                            }
                            {...cell.getCellProps()}
                            {...row.getToggleRowExpandedProps({
                              title: undefined,
                            })}
                          >
                            <div className={styles.table_label}>
                              {dublicatedcontent.dublicatedText64}
                            </div>
                            {cellLength ? (
                              <div className={styles.beneficiary_wrap}>
                                {cell.render("Cell")}
                                {cellLength > 5 && (
                                  <span className={styles.more}>...</span>
                                )}
                              </div>
                            ) : (
                              <div className={styles.no_items}>None</div>
                            )}
                          </td>
                        );
                      } else {
                        return (
                          <td
                            className={styles.td}
                            {...cell.getCellProps()}
                            {...row.getToggleRowExpandedProps({
                              title: undefined,
                            })}
                          >
                            {cell.render("Cell")}
                          </td>
                        );
                      }
                    })}
                  </tr>
                  {row.isExpanded ? null : null}
                </React.Fragment>
              );
            })}
          </tbody>
        ) : (
          <tbody>
            <tr className={styles.no_grid}>
              <td colSpan={4} className={styles.assets_cell_empty}>
                <div className={styles.assets_empty}>
                  <div>You have no asset assigned to you</div>
                  <img className={styles.cash_img} src={cashImg} />
                </div>
              </td>
            </tr>
          </tbody>
        )}
      </table>
      {assetsLength.length ? (
        <TableFooter
          setPageSize={setPageSize}
          pageSize={pageSize}
          maxPage={pageOptions.length}
          pageIndex={pageIndex}
          previousPage={previousPage}
          nextPage={nextPage}
          canNextPage={canNextPage}
          canPreviousPage={canPreviousPage}
        ></TableFooter>
      ) : null}
    </>
  );
}
